var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLongGameLogoSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73.594803,
    height: 77,
    viewBox: "0 0 73.594803 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs10"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 59.1498,77 H 2.5939941e-8 V 14.6818 L 14.3394,0.211243 H 73.5948 V 62.6351 Z M 15.8155,51.5446 54.8268,14.7874 h -29.522 l -9.4893,9.4005 z m 32.4743,10.8793 9.384,-9.4006 V 25.6667 l -38.906,36.7572 z",
    fill: "#acff01",
    id: "path2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 15.8155,51.5446 54.8268,14.7874 h -29.522 l -9.4893,9.4005 z",
    fill: "#acff01",
    id: "path5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m 48.2898,62.4239 9.384,-9.4006 V 25.6667 l -38.906,36.7572 z",
    fill: "#acff01",
    id: "path6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 14.156,27.7426 35.1787,0 c 0,0 -2.2727,6.79412 -5.6818,13.0221 -3.4091,6.2279 -1.7046,7.9264 1.7045,5.0955 C 34.6105,15.2868 49.3828,0 49.3828,0 L 34.6105,22.6471 h 12.5003 v 2.8308 l 0.152,0.0954 c 5.11,3.2029 8.021,5.0276 10.075,10.0958 l -2.273,1.6985 c 1.666,6.04 1.63,9.2303 0.568,14.7206 l -3.409,-1.1323 C 44.8488,64.571 35.2347,75.0171 50.5198,77 H 21.5423 C 32.5827,60.3191 48.2468,43.5956 40.2928,39.6324 30.3079,34.6577 14.7242,60.0147 18.7014,61.1471 c 2.2979,0.6542 -5.6818,2.2647 -5.6818,2.2647 l -5.6818,-9.625 c 0.4633,-6.849 0.9389,-10.543 2.8409,-16.4192 v 9.0589 C 14.274,40.2034 14.9716,36.039 14.156,27.7426 Z",
    fill: "#000000",
    id: "path7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m 21.5423,28.875 c -1.9673,4.2979 -2.4275,6.7793 -2.2727,11.3235 5.4426,-2.6374 6.1932,-5.0176 2.2727,-11.3235 z",
    fill: "#acff01",
    id: "path8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m 12.662,52.7193 c 0.1249,-0.6538 0.287,-1.3063 0.4407,-1.8656 0.2119,-0.7716 1.1426,-1.0059 1.5452,-0.3138 0.5292,0.91 0.781,2.1389 -0.6993,3.1197 -0.664,0.4399 -1.4358,-0.1598 -1.2866,-0.9403 z",
    fill: "#acff01",
    id: "path9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m 21.5424,28.875 c -1.9674,4.2979 -2.4276,6.7793 -2.2728,11.3235 5.4426,-2.6374 6.1932,-5.0176 2.2728,-11.3235 z",
    fill: "#acff01",
    id: "path10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongGameLogoSquare);
export default __webpack_public_path__ + "static/media/long-game-logo-square.01969aa9349dea378e122c8d4c59b528.svg";
export { ForwardRef as ReactComponent };